import axios from "axios";
import ConnectionClient from "../../shared/api-client";

export const getValidationResult = async (id: string) => {
    const client = new ConnectionClient();
    const result = await client.api.get(`${process.env.REACT_APP_API_HOST}/files/${id}`);
    return result.data;
}

export const upload = async (file: File, uploadType?: string) => {
    const client = new ConnectionClient();
    let form = new FormData();

    if (uploadType) {
        form.append('folder', '028518a2-aa2e-40fb-9875-8aa484c4124f');
        form.append('upload_type', uploadType);
    }

    form.append('file', file, 'file');
    const result = (await client.api.post(`${process.env.REACT_APP_API_HOST}/files`, form, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }));
    return result.data;
}
export const executeimport = async (fileId: string) => {
    const client = new ConnectionClient();

    const result = (await client.api.post(`${process.env.REACT_APP_API_HOST}/import/file`, {
        id: fileId
    }));
    
    return result.data;
}



